import React from 'react';

const ImageUploader = ({ image, onChange, isReadOnly }) => {
  return (
    <div style={{ width: '120px', height: '100px' }}>
      <label htmlFor="imageUpload" style={{ cursor: isReadOnly ? 'default' : 'pointer' }}>
        <img
          src={image || '/assets/images/image_placeholder.png'}
          alt=""
          style={{ width: '120px', height: '100px' }}
        />
      </label>
      {!isReadOnly && (
        <input
          type="file"
          id="imageUpload"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={onChange}
        />
      )}
    </div>
  );
};

export default ImageUploader;
